__webpack_require__.p = "/dnevnik/";